<template>
    <vx-dropdown class="dropdown" vs-custom-content vs-trigger-click>
        <span class="span-select underline">
            <span v-if="value">{{ text }}</span>
            <span v-else>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
            <vx-action-icon class="ml-2" :size="5" icon="ChevronDownIcon"></vx-action-icon>
        </span>
        <vs-dropdown-menu>
            <vs-dropdown-item
                v-for="(option, index) in options"
                :key="index"
                @click="select(option)"
            >
                {{ getText(option) }}
            </vs-dropdown-item>
            <vs-divider class="m-1"></vs-divider>
            <vs-dropdown-item @click="clear">
                Clear
            </vs-dropdown-item>
        </vs-dropdown-menu>
    </vx-dropdown>
</template>

<script>
export default {
    name: 'vx-span-select',
    props: {
        value: {
            type: null
        },
        options: {
            type: Array,
            default: () => []
        },
        valueKey: {
            type: null
        },
        textKey: {
            type: null
        }
    },
    computed: {
        text() {
            if (this.value) {
                return this.getText(this.value)
            }
        }
    },
    methods: {
        clear() {
            this.$emit('input', null)
        },
        select(val) {
            this.$emit('input', val)
        },
        getText(item) {
            if (typeof item === 'object') {
                if (this.textKey) {
                    if (typeof this.textKey === 'function') {
                        return this.textKey(item)
                    }
                    return item[this.textKey]
                }
                return item[this.valueKey]
            }
            return item
        },
        getValue(item) {
            if (this.valueKey && typeof item === 'object') {
                return item[this.valueKey]
            }
            return item
        }
    }
}
</script>

<style scoped>
.vs-con-dropdown {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
}
.span-select {
    cursor: pointer;
}
</style>
